import { render, staticRenderFns } from "./SidebarCrmHistoryBlock.vue?vue&type=template&id=c5755d5a&scoped=true"
import script from "./SidebarCrmHistoryBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarCrmHistoryBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarCrmHistoryBlock.vue?vue&type=style&index=0&id=c5755d5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5755d5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5755d5a')) {
      api.createRecord('c5755d5a', component.options)
    } else {
      api.reload('c5755d5a', component.options)
    }
    module.hot.accept("./SidebarCrmHistoryBlock.vue?vue&type=template&id=c5755d5a&scoped=true", function () {
      api.rerender('c5755d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarCrmHistoryBlock.vue"
export default component.exports